module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/first.js
// module id = 2389
// module chunks = 0